export default "__VITE_ASSET__7765eef2__"